<template>
    <div class="invitation-wrapper">
        <div class="bg-invitation">
            <h1>{{ name }}</h1>
            <div class="flex justify-center ">
                <img alt="" src="../assets/img/invitation-title.png">
            </div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="input-form">
                <el-form-item ref="morglogo" class="form-row-item flex align-center margin-tb-sm" label="机构LOGO"
                              prop="morglogo">
                    <el-upload
                        :action="`${baseURL}/home/img/upload`"
                        :data="fileData"
                        :name="'file'"
                        :on-success="handleAvatarSuccess"
                        :show-file-list="false"
                        accept="image/*"
                        class="avatar-uploader margin-left"
                    >
                        <div class="flex align-center">
                            <el-image v-if="ruleForm.morglogo" :src="ruleForm.morglogo" class="logo "></el-image>
                            <div v-else class="logo up">点击上传</div>
                            <div slot="tip" class="el-upload__tip margin-left">推荐尺寸大小120px*120px,5M以内</div>
                        </div>
                    </el-upload>
                </el-form-item>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item ref="morgname" class="input-container" label="机构名称" labelWidth="100px"
                                      prop="morgname">
                            <el-input v-model="ruleForm.morgname" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item ref="rankId" class="input-container" label="分会等级" labelWidth="100px" prop="rankId">
                            <el-select v-model="ruleForm.rankId" placeholder="请选择分会等级">
                                <el-option
                                    v-for="item in levelList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item ref="contacts" class="input-container" label="联系人" labelWidth="100px" prop="contacts">
                            <el-input v-model="ruleForm.contacts" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item ref="morgtel" class="input-container" label="联系电话" labelWidth="100px" prop="morgtel">
                            <el-input v-model="ruleForm.morgtel" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item ref="address" class="input-container" label="机构地址" labelWidth="100px" prop="address">
                            <el-input v-model="ruleForm.address" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item ref="morgemail" class="input-container" label="邮箱" labelWidth="100px"
                                      prop="morgemail">
                            <el-input v-model="ruleForm.morgemail" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item ref="morgurl" class="input-container" label="网址" labelWidth="100px"
                                      prop="morgurl">
                            <el-input v-model="ruleForm.morgurl" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="page-title margin-tb-sm">分会介绍</div>

                <el-form-item ref="morgdesc" class="margin-bottom-sm" label="机构介绍" labelWidth="90px" prop="morgdesc">
                    <div class="input-container padding-xs">

                        <VueUditorWrap v-model="ruleForm.morgdesc" :config="myConfig"></VueUditorWrap>
                    </div>
                </el-form-item>

                <div class="flex align-center justify-center margin-bottom-sm">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <span class="margin-left-xs" style="cursor: pointer"
                          @click="centerDialogVisible = true"> 请仔细阅读《入会须知》</span>
                </div>
                <div class="flex align-center justify-center margin-tb">
                    <el-button :loading="loading" class="input-form-btn" type="primary"
                               @click="submitForm('ruleForm')">申请加入
                    </el-button>
                </div>
                    <div class="info-tip">填写过程有任何问题请拨打电话：{{ kefu_tel }}</div>
            </el-form>
        </div>
        <footer-modular :state="false"></footer-modular>
        <el-dialog
            :visible.sync="centerDialogVisible"
            center
            title="入会须知"
            width="60%">
            <div v-html="agreement"></div>
            <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
import FooterModular from "@/components/FooterLinkModular.vue";
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils"
import rules from "@/utils/rules";
import {getCompanyUserMoreJson,fhApply,getApplyRankList} from "@/api/login";
import {baseURL} from "@/config";

export default {
    name: "invitation",
    data() {
        return {
            myConfig: bdEditConfig(),
            baseURL: baseURL,
            id: '',
            name: '',
            kefu_tel: '',
            ruleForm: {
                morglogo: '',
                morgname: '',
                rankId: '',
                contacts: '',
                morgtel: '',
                address: '',
                morgemail: '',
                morgurl: '',
                morgdesc: '',
            },
            rules: {
                morglogo: [{required: true, message: "请上传机构LOGO", trigger: "change"}],
                morgname: [
                    {required: true, message: '请输入机构名称', trigger: 'blur'}
                ],
                rankId: [{required: true, message: "请选择分会等级", trigger: "change"}],
                contacts: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                morgtel: rules.tel,
                address: [
                    {required: true, message: '请输入地址', trigger: 'blur'}
                ],
                morgemail: [
                    {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
                ],
                // morgurl: [
                //   {required: true, message: '请输入网址', trigger: 'blur'}
                // ],
                // morgdesc: [
                //   {required: true, message: '请输入机构介绍', trigger: 'blur'}
                // ],

            },
            loading: false,
            centerDialogVisible: false,
            agreement: '',
        }
    },
    created() {
        this.getRankList()
        this.getInformation()
    },
    computed: {
        fileData() {
            return {
                uptype: 1,
                path: 'head'
            }
        }
    },
    components: {VueUditorWrap, FooterModular},
    methods: {
        //  获取表单
        async getInformation() {
            let _data = await getCompanyUserMoreJson(this.$route.params.id)
            this.name = _data.data.orgData.morgname
            this.agreement = _data.data.ruHuiContent
            this.kefu_tel = _data.data.kefu_tel
        },
        submitForm(formName) {

            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    if (!this.checked) return this.$message.error('请仔细阅读并同意《入会须知》！')
                    this.submitChange();
                } else {
                    let error = Object.values(validates).shift().shift()
                    let dom = this.$refs[error.field]
                    this.$confirm(error.message, "提示", {
                        confirmButtonText: "确定",
                        showCancelButton: false,
                        type: "warning",
                    }).then(() => {
                        dom.$el.scrollIntoView({
                            block: 'center', // 当前元素显示在视图区域中间
                            behavior: 'auto' // 滚动速度
                        })
                    })
                }
            });
        },
        async submitChange() {
            this.loading = true
            let _data = await fhApply(this.$route.params.id, this.ruleForm.morglogo, this.ruleForm.morgname,
                this.ruleForm.rankId, this.ruleForm.contacts, this.ruleForm.morgtel, this.ruleForm.address,
                this.ruleForm.morgemail, this.ruleForm.morgurl, this.ruleForm.morgdesc)
            this.loading = false
            if (_data.status === 200) {
                this.$alert('恭喜您申请成功，请等待机构审核', '温馨提示', {
                    confirmButtonText: '确定',
                    center: true,
                    callback: () => {
                        this.$router.push('/')
                    }
                });
            }
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getApplyRankList(this.$route.params.id,2)
            this.levelList = _list.data
        },
        handleAvatarSuccess(res) {
            if (res.code === 1) {
                this.ruleForm.morglogo = this.baseURL +  res.path
            } else {
                this.$message.error(res.info)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.invitation-wrapper {
    .bg-invitation {
        width: 100%;
        min-height: 100vh;
        padding: 80px;
        background: url(../assets/img/invitation-bg.jpg) #587fb0 no-repeat top center;
        background-size: 100%;

        h1 {
            text-align: center;
            font-size: 36px;
            line-height: 48px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-bottom: 20px;
        }
    }
    .el-select {
        width: 100%;
    }
    .info-tip {
        text-align: center;
        font-size: 20px;
        color: red;
        font-weight: bold;
        margin-top: 20px;
    }

    .input-form {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px 30px;
        margin-top: 30px;

        .logo {
            width: 80px;
            height: 80px;
            border-radius: 80px;

            &:hover {
                border: 1px dotted #fc7802;
            }

            &.up {
                border: 1px dotted #999999;
                line-height: 80px;
                text-align: center;
            }
        }

        .morgdesc {
            border-radius: 10px;
            border: solid 1px #dae0e6;
            padding: 12px;
        }

        .input-form-btn {
            width: 200px;
            height: 40px;
            line-height: 40px;
            border-radius: 40px;
            font-size: 16px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#ff9600, #ff9600);
            background-blend-mode: normal, normal;
            color: #ffffff;
            margin-top: 20px;
            padding: 0;

            &.white {
                background: #ffffff none;
                color: #ff9600;
            }
        }
    }

}
</style>